export default "__VITE_ASSET__DboZ7gN8__"